// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"46":"f463652b","249":"2f4df665","337":"310f477d","357":"dfcdfbf7","453":"d855a71b","487":"68f6410a","583":"7b613566","916":"3d9ac667","936":"55f56cb9","944":"e9294b3a","954":"340d4f72"}[chunkId] + ".chunk.js";
};